import { useContext } from "react";
import UserContext from "../../context/userContext";
import Amenidades from "./Amenidades";
import { AmenidadesAdm } from "./AmenidadesAdm";


export const AmenidadesMain = () => {
    const { user, setUser } = useContext(UserContext);
    return (
        <div className="mt-lg-3 mx-lg-5 m-2">
            {user.admin ? 
                <AmenidadesAdm/>
                :
                <Amenidades/>
            }
        </div>
    );
}